export function buildLinksSearchFilters(query = '') {
  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return {};
  }

  return {
    'filters[$or][0][Name][$containsi]': trimmedQuery,
    'filters[$or][1][Description][$containsi]': trimmedQuery,
    'filters[$or][2][Link][$containsi]': trimmedQuery,
    'filters[$or][3][manufacturers][Name][$containsi]': trimmedQuery,
  };
}

export function buildLinksManufacturerFilters(selectedManufacturers = []) {
  return selectedManufacturers.reduce((filters, manufacturerId, index) => ({
    ...filters,
    [`filters[manufacturers][id][$in][${index}]`]: manufacturerId,
  }), {});
}

export function getActiveLinksFilterCount(query = '', selectedManufacturers = []) {
  const searchCount = query.trim() ? 1 : 0;

  return searchCount + selectedManufacturers.length;
}

export function getLinkHref(link = '') {
  const trimmedLink = link.trim();

  if (!trimmedLink) {
    return '#';
  }

  return /^https?:\/\//i.test(trimmedLink) ? trimmedLink : `https://${trimmedLink}`;
}

export function getManufacturerNames(item = {}) {
  const names = (item?.manufacturers || [])
    .map((manufacturer) => manufacturer?.Name)
    .filter(Boolean);

  return names.length ? names : ['Bez producenta'];
}
